import { Filters } from "./filter";
import { User } from "./user";

export class GroupRestriction {
  uuid: string;
  name: string;
  filters: Filters;
  users: User[];
}
